import CheckCircle from '@/components/customercenter-ui/icons/checkCircle';
import StoneberryIcon from '@/components/customercenter-ui/icons/stoneberry';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

const OrderConfirmBanner = () => {
  return (
    <>
      <section className="mx-4 flex gap-x-0 bg-[#89CDDA33] md:gap-x-5">
        <section className="pl-6 pt-7 md:pl-8 md:pt-7">
          <StoneberryIcon className="h-10 w-10 md:h-12 md:w-12" />
        </section>
        <section className="pt-6 text-center md:py-9 md:text-left">
          <p className="pl-3 text-3xl font-bold text-deepBlue md:inline-block md:pl-0 md:text-3xl">
            Congratulations!&nbsp;
          </p>
          <p className="text-xl font-normal text-deepBlue md:inline-block  md:text-3xl">Your Stoneberry Credit</p>
          <p className="pb-6 text-xl font-normal text-deepBlue md:inline-block md:pb-0 md:text-3xl">
            &nbsp;Order Has Been Approved!
          </p>
        </section>
      </section>
    </>
  );
};

const OrderConfirmMessage = ({ order }: any) => {
  return (
    <>
      <section className="w-full md:max-w-[1141px]">
        <p className="flex flex-row gap-x-3 pt-8 text-2xl font-bold text-forestGreen">
          {' '}
          <CheckCircle className="h-7 w-7" color={'forestGreen'} />
          Order Placed Successfully.&nbsp;
          {mapLocaleToMeaningfulFormat().orderHash}
          <span className="gbmask">{order?.orderNumber}</span>
        </p>
      </section>
    </>
  );
};

export { OrderConfirmBanner, OrderConfirmMessage };
